import { DEFAULT_ICON_SIZE } from '@gitbook/spine-icons';

export const XXS = 18; // px
export const XS = 24; // px
export const S = 32; // px
export const M = 48; // px
export const L = 64; // px
export const XL = 80; // px
export const XXL = 105; // px
export const XXXL = 210; // px

// Border Radius -- Deprecated use the tokens instead
export const RADIUS_M = 4;
export const RADIUS_L = 6;
export const RADIUS_XL = 8;

// Icons
export const ICON_100 = 12;
export const ICON_200 = 14;
export const ICON_300 = 16;
export const ICON_400 = DEFAULT_ICON_SIZE; // 18px
export const ICON_500 = 20;
export const ICON_600 = 24;
export const ICON_700 = 28;
export const ICON_800 = 30;
export const ICON_900 = 32;
export const ICON_925 = 48;
export const ICON_950 = 64;

// Button height
export const BUTTON_XS = 20;
export const BUTTON_S = 24;
export const BUTTON_M = 32;
export const BUTTON_L = 36;
export const BUTTON_XL = 48;

// Button padding
export const BUTTON_PADDING_S = 8;
export const BUTTON_PADDING_M = 12;
export const BUTTON_PADDING_L = 16;

// Avatar size
export const AVATAR_XS = 24;
export const AVATAR_M = 36;
